import { apiRequest } from '@/api/helpers/apiRequest';
import type { SoftDeleteStoryTemplateResponse } from 'schemas';
import { SoftDeleteStoryTemplateResponseSchema } from 'schemas';

/**
 * Soft deletes a story template by ID.
 * @param templateId - The UUID of the story template to delete
 * @returns Promise that resolves when the template is successfully deleted
 */
export const softDeleteStoryTemplate = async (
  templateId: string
): Promise<{ message: string; deletedTemplateId: string }> => {
  return await apiRequest<
    { message: string; deletedTemplateId: string },
    SoftDeleteStoryTemplateResponse
  >(
    'PUT',
    `/api/story-templates/${templateId}/delete`,
    {},
    SoftDeleteStoryTemplateResponseSchema
  );
};
